if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"host","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return 920 != chunkId},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}